// src/components/AddEditStaffModal/hooks/useStaffForm.js
import { useState, useEffect, useMemo } from 'react';
import { useFormik } from 'formik';
import { staffValidationSchema } from '../validationSchema';
import moment from 'moment';
import {
    createStaff,
    editStaff,
    getSingleStaff,
    getSalaryTypeList,
    getBaseRateTypeList,
    getLeadSourceList,
    getchZoneList,
    getHubList,
    getStaffTypeList,
    getRateCard,
    fetchClientList,
    getStaffCityZones,
    getHubListWithFilters,
    getBlueDartServiceCentres,
    getBlueDartRollCodes,
    getEducationalQualifications,
    getBdUniformSizeOptions,
} from '../../../../store/actions/staffActionCreator';
import { fetchVendorList } from '../../../../store/actions/staffActionCreator';
import { Button } from '@material-ui/core';
import { HUB_TYPE_ENUM, CUSTOM_ERROR_CODES } from '../../../../utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import {
    fetchShiftfilterList,
    GetBusinessList,
} from '../../../../store/actions/settingsActionCreator';
import { checkHttpStatus, showMessage } from '../../../../utils/helper';
import {
    fetchVehicleTypes,
    fetchVehicleTypesV2,
} from '../../../../store/actions/attendanceActionCreator';
import Swal from 'sweetalert2';
import { shiftOverlapValidation } from '../../AssignStaffToHubModal';
import { isEqual } from 'lodash';
import { validateHubSelection } from '../helper';
import { isBlueDartOrg } from '../../../../utils/appHelper';
export function useStaffForm({ onClose, isEdit, data = {} }) {
    const dispatch = useDispatch();
    const operatingCityId = useSelector(
        (state) => state?.settings?.basicDetails?.operatingCityId,
    );
    const orgId = useSelector((state) => state?.settings?.basicDetails?.id);
    const vendorName = useSelector(
        (state) => state?.settings?.basicDetails?.vendorName,
    );
    const isPinCodeOrg = vendorName === 'PINCODE';
    const isAmazonOrg = vendorName === 'AMAZON';
    const isDedicatedSlotEnabled = useSelector(
        (state) => state?.settings?.basicDetails?.dedicatedSlotBooking ?? false,
    );
    const removeShift = useSelector(
        (state) =>
            state?.settings?.basicDetails?.settingsMap?.removeShift === 'true',
    );
    const hubs = useSelector((state) => state?.staff?.hubs);
    const staffTypes = useSelector((state) => state?.staff?.types);
    const leadSources = useSelector((state) => state?.staff?.leadSources);
    const orgCustomerMappings = useSelector(
        (state) => state?.settings?.orgCustomerMappings,
    );

    const isBlueDart = !!isBlueDartOrg?.();

    const initialValues = {
        name: '',
        contactNumber: '',
        dateOfBirthEpochMillis: null,
        joiningDateEpochMillis: isBlueDart ? moment().valueOf() : null,
        staffTypeId: '',
        vehicleTypeId: '',
        vehicleNumber: isBlueDart ? 'BLUEDART' : '',
        selfieEnabled: true,
        trackAndTraceEnabled: true,
        geofenceAutoApproval: true,
        hubId: '',
        zones: [],
        shiftTimingIds: [],
        trainingCompleted: false,
        freelancer: false,
        salaryType: 4,
        salaryCycle: '',
        salaryCycleDay: '',
        baseRate: '',
        baseRateType: '',
        openingBalance: '',
        staffCustCode: '',
        vendorId: '',
        customerId: '',
        clients: [],
        // Amazon orgs must pick the source explicitly — no pre-filled default
        userCreationSource: isAmazonOrg ? '' : 'Self Onboarded',
        userCreationSourceId: '',
        sourceRemarks: '',
        // Blue Dart specific
        gender: '',
        sccCode: '',
        employeeMode: '',
        rollCode: '',
        interviewTaken: false,
        documentValidation: false,
        aadhaarVerified: false,
        panVerified: false,
        dlVerified: false,
        educationalQualification: '',
        emailId: '',
        uniformIssueDate: null,
        shirtSize: '',
        trouserSize: '',
        shoeSize: '',
        maskDetails: false,
    };
    const [workTabHubNShiftList, setWorkTabHubNShiftList] = useState([{}]);
    let validateHub = validateHubSelection(workTabHubNShiftList);
    const formik = useFormik({
        initialValues,
        validationSchema: staffValidationSchema({
            isDedicatedSlotEnabled: !!validateHub?.hasDedicated,
            removeShift: removeShift,
            isBlueDartOrg: isBlueDart,
            staffTypes,
            operatingCityId,
            isEdit,
        }),
        onSubmit: async (
            state,
            { setFieldError, setSubmitting, ...formikbag },
        ) => {
            try {
                console.log('Formik formikbag:', formikbag);
                setLoading(true);
                let shiftTimingIds = [];
                let isFoodHubSelected = false;
                let hubValidation = validateHubSelection(workTabHubNShiftList);
                if (hubValidation?.hasDedicated && !hubValidation?.isValid) {
                    Swal.fire({
                        icon: 'error',
                        title: 'HUBS',
                        text:
                            hubValidation?.reason ??
                            'Cannot mix slots and normal hubs. Please check',
                    });
                    setLoading(false);
                    return;
                } else if (
                    hubValidation?.hasDedicated &&
                    hubValidation?.isValid
                ) {
                    state.hubId = workTabHubNShiftList?.[0]?.hubId;
                } else {
                    state.hubId = null;
                }
                const staffType = staffTypes?.find(
                    (t) => String(t?.id) === String(state?.staffTypeId),
                );
                let isInHouseStaff = !!staffType?.name
                    ?.toLowerCase()
                    ?.includes('in house');

                workTabHubNShiftList?.forEach((hub) => {
                    if (hub?.primaryOperation === HUB_TYPE_ENUM.FOOD.value) {
                        isFoodHubSelected = true;
                    }
                    if (hub?.shifts?.length)
                        shiftTimingIds = [
                            ...shiftTimingIds,
                            ...hub?.shifts
                                ?.filter((s) => s?.id && !s.dedicatedSlotShift)
                                .map((s) => s?.id),
                        ];
                });
                let zoneId = [];
                Object.keys(zonesWithHub).forEach((zone) => {
                    zoneId = [
                        ...zoneId,
                        ...(zonesWithHub[zone].map((z) => z?.id) ?? []),
                    ];
                });
                if (
                    !zonesWithHub?.FOOD?.length &&
                    !state?.zones?.length &&
                    isFoodHubSelected &&
                    !isEdit
                ) {
                    formik.setFieldError(
                        'zones',
                        'At least one zone must be selected',
                    );
                    setLoading(false);
                    return;
                } else {
                    formik.setFieldError('zones', null);
                    formik.setTouched({
                        zones: false,
                    });
                }
                let userCreationSourceId = leadSources?.staticValues
                    .filter((x) => x.name === state?.userCreationSource)
                    .map((x) => x.id)[0];
                let vendorId =
                    state.userCreationSource &&
                    state.userCreationSource === 'Vendor'
                        ? state?.vendorId
                        : null;
                // A masked number (edit mode) is not a number -- stripping it would submit its digits alone.
                const isMaskedContactNumber =
                    !!state?.maskDetails ||
                    /^X+\d+$/i.test(state?.contactNumber || '');
                const cleanedContactNumber = isMaskedContactNumber
                    ? state?.contactNumber
                    : state?.contactNumber?.replace(/\D/g, '');
                const commonValues = {
                    name: state?.name,
                    contactNumber: cleanedContactNumber,
                    vehicleTypeId: !!isInHouseStaff
                        ? null
                        : state?.vehicleTypeId,
                    vehicleNumber: isBlueDart
                        ? cleanedContactNumber
                        : !!state?.vehicleNumber
                          ? state?.vehicleNumber
                          : cleanedContactNumber,
                    hubId: state?.hubId ?? null,
                    selfieEnabled: state?.selfieEnabled,
                    // geofenceEnabled: state?.geofenceEnabled,
                    trackAndTraceEnabled: state?.trackAndTraceEnabled,
                    geofenceAutoApproval: state?.geofenceAutoApproval,
                    // companyId: state?.companyId,
                    dateOfBirthEpochMillis: moment(
                        state?.dateOfBirthEpochMillis,
                    ).valueOf(),
                    staffType: state?.staffTypeId,
                    salaryType: state?.salaryType,
                    salaryCycle: state?.salaryCycle,
                    salaryCycleDay: state?.salaryCycleDay,
                    openingBalance: state?.openingBalance,
                    baseRate: state?.baseRate,
                    baseRateType: state?.baseRateType,
                    freelancer: state?.freelancer,
                    staffCreatedSoruce: 'CREATE_STAFF',
                    staffCustCode: state?.staffCustCode,
                    vendorId,
                    userCreationSourceId: userCreationSourceId ?? null,
                    userCreationSource: state?.userCreationSource || null,
                    sourceRemarks: state?.sourceRemarks,
                    customerId: state?.customerId,
                    customers:
                        state?.clients?.filter(
                            (item) => !!item && item?.customerId,
                        ) ?? [],
                    shiftTimingIds,
                    isTrainingCompleted: trainingCompleted === 'true',
                    joiningDateEpochMillis:
                        state?.joiningDateEpochMillis === 0
                            ? moment().valueOf()
                            : moment(state?.joiningDateEpochMillis).valueOf(),
                    zoneId,
                    // Blue Dart specific
                    ...(isBlueDart && {
                        gender: state?.gender,
                        sccCode: state?.sccCode,
                        employeeMode: state?.employeeMode,
                        rollCode: state?.rollCode,
                        interviewTaken: state?.interviewTaken,
                        documentValidation: state?.documentValidation,
                        aadhaarVerified: state?.aadhaarVerified,
                        panVerified: state?.panVerified,
                        dlVerified: state?.dlVerified,
                        educationalQualification: state?.educationalQualification,
                        emailId: state?.emailId || null,
                        uniformIssueDate: state?.uniformIssueDate
                            ? moment(state.uniformIssueDate).format('YYYY-MM-DD')
                            : null,
                        shirtSize: state?.shirtSize || null,
                        trouserSize: state?.trouserSize || null,
                        shoeSize: state?.shoeSize || null,
                    }),
                };
                if (isEdit) {
                    let payload = {
                        id: state?.id,
                        value: commonValues,
                    };
                    dispatch(
                        editStaff(
                            payload,
                            async () => {
                                setLoading(false);
                                onClose();
                                showMessage(
                                    'Staff Edited Successfully',
                                    'success',
                                );
                            },
                            async () => {
                                setLoading(false);
                                showMessage(
                                    'Failed to edit staff. Please try again.',
                                    'error',
                                );
                            },
                        ),
                    );
                } else {
                    let payload = {
                        ...commonValues,
                        dateOfBirthEpochMillis: moment(
                            state?.dateOfBirthEpochMillis,
                        ).valueOf(),
                        customers:
                            state?.clients?.filter(
                                (item) => !!item && item?.customerId,
                            ) ?? [],
                        staffCreatedSoruce: 'CREATE_STAFF',
                    };
                    dispatch(
                        createStaff(
                            payload,
                            async (response) => {
                                setLoading(false);
                                if (
                                    response?.status?.customErrorCode ===
                                    CUSTOM_ERROR_CODES.CONFIRMATION_REQUIRED
                                ) {
                                    await handleOrgOverrideConfirmation(
                                        payload,
                                        response?.status?.message,
                                    );
                                    return;
                                }
                                onClose();
                                showMessage(
                                    'Staff Created Successfully',
                                    'success',
                                );
                            },
                            async () => {
                                setLoading(false);
                                showMessage(
                                    'Failed to create staff. Please try again.',
                                    'error',
                                );
                            },
                        ),
                    );
                }
            } catch (error) {
                console.error('Error submitting form:', error);
                setLoading(false);
            }
        },
    });

    const [loading, setLoading] = useState(false);

    const [activeTab, setActiveTab] = useState(0);

    // "Source of Delivery Boy" lives at the bottom of Basic Info and is
    // mandatory (BD hides the section) — block leaving the tab until it's set.
    const handleTabChange = (_, nextTab) => {
        if (
            activeTab === 0 &&
            nextTab !== 0 &&
            !isBlueDart &&
            !formik?.values?.userCreationSource
        ) {
            formik.setFieldTouched('userCreationSource', true, false);
            Swal.fire({
                icon: 'error',
                title: 'Source of Delivery Boy',
                text: 'Please select the source of delivery boy before moving to the next tab.',
            });
            return;
        }
        setActiveTab(nextTab);
    };
    const [salaryTypeList, setSalaryTypeList] = useState([]);
    const [salaryCycleList] = useState([
        { id: 1, name: 'Weekly', value: 'Weekly' },
        {
            id: 2,
            name: 'Bi-Weekly',
            value: 'Bi-Weekly',
        },
        {
            id: 3,
            name: 'Monthly',
            value: 'Monthly',
        },
    ]);
    const [salaryCycleDayList, setSalaryCycleDayList] = useState([]);
    const [rateCardResponse, setRateCardResponse] = useState({});
    const [baseRateTypesList, setBaseRateTypesList] = useState([]);
    const [filteredBaseRateTypesList, setFilteredBaseRateTypesList] = useState(
        [],
    );

    const [vehicleTypesList, setVehicleTypesList] = useState([]);
    const [clientList, setClientList] = useState([]);
    const [vendorList, setVendorList] = useState([]);
    const [weekList, setWeekList] = useState([]);
    const [weekDaysList, setWeekDaysList] = useState([]);

    // Blue Dart specific state
    const [sccList, setSccList] = useState([]);
    const [rollCodeList, setRollCodeList] = useState([]);
    const [educationalQualificationOptions, setEducationalQualificationOptions] = useState([]);
    const [shirtSizeOptions, setShirtSizeOptions] = useState([]);
    const [trouserSizeOptions, setTrouserSizeOptions] = useState([]);
    const [shoeSizeOptions, setShoeSizeOptions] = useState([]);

    const [shiftsWithHub, setShiftsWithHub] = useState({});
    const [zonesWithHub, setZonesWithHub] = useState({
        [HUB_TYPE_ENUM.FOOD.value]: [],
        [HUB_TYPE_ENUM.ECOM.value]: [],
        [HUB_TYPE_ENUM.STORE.value]: [],
    });

    const [rateCardPayload, setRateCardPayload] = useState({
        userId: isEdit ? data?.id : null,
        hubId: formik.values?.hubId ?? null,
        staffCustCode: isEdit ? data?.staffCustCode : null,
    });

    const [overlapShifts, setOverlapShift] = useState([]);
    const [bothShiftsIsThere, setBothShiftsIsThere] = useState(false);
    const [isSubmitButtonDisabled, setSubmitButtonDisabled] = useState(true);
    const [allowHubZoneEdit, setAllowHubZoneEdit] = useState(!isEdit);
    const [trainingCompleted, setTrainingCompleted] = useState(
        data?.trainingCompleted != null
            ? data?.trainingCompleted.toString()
            : 'false',
    );

    // {hubId1 : [], hubId2 : []}
    const [zoneOptions, setZoneOptions] = useState({});

    const modalTitle = isEdit ? 'Edit Staff' : 'Add New Staff';

    const fetchVendor = () => {
        dispatch(
            fetchVendorList(
                (resp) => {
                    setVendorList(resp?.response?.vendors);
                },
                (err) => {},
            ),
        );
    };
    const getLeadSourcesList = () => {
        dispatch(
            getLeadSourceList(
                'LEAD_SOURCE',
                (resp) => {
                    !isEdit && setLoading(false);
                },
                (resp) => {
                    !isEdit && setLoading(false);
                },
            ),
        );
    };

    const fetchSccList = () => {
        dispatch(
            getBlueDartServiceCentres(
                (resp) => {
                    if (checkHttpStatus(resp?.status)) {
                        setSccList(resp?.response?.serviceCentreDetails ?? []);
                    }
                },
                () => {},
            ),
        );
    };

    const fetchEducationalQualifications = () => {
        dispatch(
            getEducationalQualifications(
                (resp) => {
                    if (checkHttpStatus(resp?.status)) {
                        const options = Object.entries(resp?.response?.configs ?? {}).map(
                            ([value, label]) => ({ value, label }),
                        );
                        setEducationalQualificationOptions(options);
                    }
                },
                () => {},
            ),
        );
    };

    const fetchUniformSizeOptions = () => {
        dispatch(
            getBdUniformSizeOptions(
                (resp) => {
                    if (checkHttpStatus(resp?.status)) {
                        const configs = resp?.response?.configs ?? {};
                        const toOptions = (arr) =>
                            (arr ?? []).map((s) => ({ label: s, value: s }));
                        setShirtSizeOptions(toOptions(configs?.shirtSizes));
                        setTrouserSizeOptions(toOptions(configs?.trouserSizes));
                        setShoeSizeOptions(toOptions(configs?.shoeSizes));
                    }
                },
                () => {},
            ),
        );
    };

    const fetchRollCodes = (staffTypeId) => {
        if (!staffTypeId) {
            setRollCodeList([]);
            return;
        }
        dispatch(
            getBlueDartRollCodes(
                staffTypeId,
                (resp) => {
                    if (checkHttpStatus(resp?.status)) {
                        setRollCodeList(resp?.response?.roleTypes ?? []);
                    }
                },
                () => {
                    setRollCodeList([]);
                },
            ),
        );
    };

    const checkRosterShiftsForConflicts = (shifts = []) => {
        let hasRosterShift = false;
        let hasNormalShift = false;
        let conflictShifts = [];
        let conflictShiftIds = new Set();

        for (let i = 0; i < shifts?.length; i++) {
            const shiftA = shifts?.[i];

            if (shiftA?.rosterShift) {
                hasRosterShift = true;
            } else {
                hasNormalShift = true;
            }

            for (let j = i + 1; j < shifts?.length; j++) {
                const shiftB = shifts?.[j];

                // **Check if Roster and Normal Shift are mixed**
                if (hasRosterShift && hasNormalShift) {
                    return {
                        conflict: true,
                        message: 'Cannot mix Roster and Normal shifts.',
                        conflictShifts: [],
                    };
                }

                // **Check for overlapping shifts on same roster days**
                if (shiftA?.rosterShift && shiftB?.rosterShift) {
                    const rosterDaysA = shiftA?.rosterDays
                        ? shiftA?.rosterDays.split(',').map(Number)
                        : [];
                    const rosterDaysB = shiftB?.rosterDays
                        ? shiftB?.rosterDays.split(',').map(Number)
                        : [];

                    const commonDays = rosterDaysA?.filter((day) =>
                        rosterDaysB?.includes(day),
                    );

                    if (commonDays?.length > 0) {
                        if (
                            (shiftA?.startTimeEpochMillis <
                                shiftB?.endTimeEpochMillis &&
                                shiftA?.endTimeEpochMillis >
                                    shiftB?.startTimeEpochMillis) ||
                            (shiftB?.startTimeEpochMillis <
                                shiftA?.endTimeEpochMillis &&
                                shiftB?.endTimeEpochMillis >
                                    shiftA?.startTimeEpochMillis)
                        ) {
                            conflictShifts?.push({
                                shiftA,
                                shiftB,
                                commonDays,
                            });
                            if (!!shiftA?.id) conflictShiftIds?.add(shiftA.id);
                            if (!!shiftB?.id) conflictShiftIds?.add(shiftB.id);
                        }
                    }
                }
            }
        }

        if (conflictShifts?.length > 0) {
            return {
                conflict: true,
                message: 'Overlapping shifts detected.',
                conflictShiftIds: Array.from(conflictShiftIds), // Convert Set to Array
                conflictShifts,
            };
        }

        return {
            conflict: false,
            message: 'No conflicts found.',
            conflictShiftIds: [],
            conflictShifts: [],
        };
    };

    function checkoverlapping() {
        let shiftIds = [];
        let isShiftOverlapping = false;

        workTabHubNShiftList.forEach((hub) => {
            shiftIds = [
                ...shiftIds,
                ...(hub?.shifts?.length ? hub?.shifts : []),
            ];
        });
        const hasRosterSelected = shiftIds.some((s) => s.rosterShift);
        const hasNormalSelected = shiftIds.some((s) => !s.rosterShift);
        if (!!hasNormalSelected && !!hasRosterSelected) {
            Swal.fire({
                icon: 'error',
                title: 'HUBS & Shifts',
                text: 'Cannot mix roster and normal shifts in the list. please check',
            });
            setBothShiftsIsThere(true);
            isShiftOverlapping = true;
            // setSubmitButtonDisabled(true);
            return isShiftOverlapping;
        } else {
            setBothShiftsIsThere(false);
        }
        if (!!hasRosterSelected) {
            const result = checkRosterShiftsForConflicts(shiftIds);
            console.log(
                'checkoverlapping roster check',
                JSON.stringify(result, null, 2),
            );
            if (result?.conflict) {
                Swal.fire({
                    icon: 'error',
                    title: 'HUBS & Shifts',
                    text:
                        result?.message ??
                        'Shift timing overlap is there please check',
                });
            }

            setOverlapShift(result?.conflictShiftIds ?? []);
            isShiftOverlapping = result?.conflict ?? false;
            // setSubmitButtonDisabled(result?.conflict ?? false);

            return isShiftOverlapping;
        } else {
            const { overlapList, overlapping } = shiftOverlapValidation(
                shiftIds?.filter((s) => !s.dedicatedSlotShift),
            );
            setOverlapShift(overlapList);
            if (overlapping) {
                Swal.fire({
                    icon: 'error',
                    title: 'HUBS & Shifts',
                    text: 'Shift timing overlap is there please check',
                });
            }
            isShiftOverlapping = overlapping;
            // setSubmitButtonDisabled(overlapping);
            return isShiftOverlapping;
        }

        // isSubmitButtonDisabled = overlapping;
        // setSubmitDisabled(overlapping);
    }

    useEffect(() => {
        const weekList = [];
        moment?.weekdays()?.forEach((day, index) => {
            weekList?.push({
                id: index,
                name: day,
                value: day,
            });
        });
        let weekDays = [];
        let days = Array.from({ length: 28 }, (_, i) => i + 1);
        // console.log('Days', days);
        days?.forEach((day, index) => {
            weekDays?.push({
                id: index,
                name: day,
                value: day,
            });
        });
        setWeekList(weekList);
        setWeekDaysList(weekDays);
        setLoading(true);

        dispatch(
            getSalaryTypeList(
                (resp) => {
                    !isEdit && setLoading(false);
                    if (checkHttpStatus(resp.status)) {
                        setSalaryTypeList(resp?.response?.types);
                    }
                },
                (resp) => {
                    !isEdit && setLoading(false);
                },
            ),
        );
        dispatch(
            getStaffTypeList(
                (resp) => {
                    !isEdit && setLoading(false);
                },
                (resp) => {
                    !isEdit && setLoading(false);
                },
            ),
        );
        dispatch(
            getBaseRateTypeList(
                (resp) => {
                    !isEdit && setLoading(false);
                    if (checkHttpStatus(resp.status)) {
                        // console.log('ZZZZZZZ', resp);
                        setBaseRateTypesList(resp?.response?.types);
                        switch (formik.values?.salaryType) {
                            case 1:
                                setFilteredBaseRateTypesList(
                                    resp?.response?.types?.filter((baseRate) =>
                                        baseRate?.name
                                            ?.toLowerCase()
                                            ?.includes('month'),
                                    ),
                                );
                                break;
                            case 2:
                                setFilteredBaseRateTypesList(
                                    resp?.response?.types?.filter((baseRate) =>
                                        baseRate?.name
                                            ?.toLowerCase()
                                            ?.includes('day'),
                                    ),
                                );
                                break;
                            case 3:
                                setFilteredBaseRateTypesList(
                                    resp?.response?.types?.filter((baseRate) =>
                                        baseRate?.name
                                            ?.toLowerCase()
                                            ?.includes('hour'),
                                    ),
                                );
                                break;
                            case 4:
                                setFilteredBaseRateTypesList(
                                    resp?.response?.types?.filter(
                                        (baseRate) =>
                                            !(
                                                baseRate?.name
                                                    ?.toLowerCase()
                                                    ?.includes('month') ||
                                                baseRate?.name
                                                    ?.toLowerCase()
                                                    ?.includes('day') ||
                                                baseRate?.name
                                                    ?.toLowerCase()
                                                    ?.includes('hour')
                                            ),
                                    ),
                                );
                                break;
                            default:
                                setFilteredBaseRateTypesList(baseRateTypesList);
                                break;
                        }
                    }
                },
                () => {},
            ),
        );
        dispatch(
            getRateCard(
                rateCardPayload,
                (resp) => {
                    // console.log('RateCardResponse', resp);
                    setLoading(false);
                    setRateCardResponse(resp?.response);
                },
                () => {
                    setLoading(false);
                },
            ),
        );
        dispatch(
            fetchClientList(
                (resp) => {
                    setClientList(resp?.response?.customers);
                },
                (err) => {},
            ),
        );
        dispatch(
            fetchVehicleTypesV2(
                operatingCityId,
                (resp) => {
                    // console.log('Vehicle Types', resp?.response);
                    setVehicleTypesList(resp?.response?.vehicleTypes);
                },
                (err) => {
                    // console.log('Vehicle Types Error', err);
                    setVehicleTypesList([]);
                },
            ),
        );
        fetchVendor();
        getLeadSourcesList();

        // Fetch BlueDart-specific data
        if (isBlueDart) {
            fetchSccList();
            fetchEducationalQualifications();
            fetchUniformSizeOptions();
        }

        if (isEdit) {
            // console.log('data', data);
            // setState(data);
            setLoading(true);
            dispatch(
                getSingleStaff(
                    data?.id,
                    (resp) => {
                        if (checkHttpStatus(resp?.status)) {
                            formik.setValues({
                                ...resp?.response,
                                clients: resp?.response?.customers ?? [],
                                joiningDateEpochMillis:
                                    resp?.response?.joiningDateEpochMillis !=
                                    null
                                        ? resp?.response?.joiningDateEpochMillis
                                        : moment().valueOf(),

                                dateOfBirthEpochMillis:
                                    resp?.response?.dateOfBirthEpochMillis !=
                                    null
                                        ? resp?.response?.dateOfBirthEpochMillis
                                        : null,
                                salaryType:
                                    resp?.response?.salaryTypeId > 0
                                        ? resp?.response?.salaryTypeId
                                        : '',
                                // Blue Dart specific - preserve from response
                                gender: resp?.response?.gender ?? '',
                                sccCode: resp?.response?.sccCode ?? '',
                                employeeMode:
                                    resp?.response?.employeeMode ?? '',
                                rollCode: resp?.response?.rollCode ?? '',
                                interviewTaken:
                                    resp?.response?.interviewTaken ?? false,
                                documentValidation:
                                    resp?.response?.documentValidation ?? false,
                                aadhaarVerified:
                                    resp?.response?.aadhaarVerified ?? false,
                                panVerified:
                                    resp?.response?.panVerified ?? false,
                                dlVerified:
                                    resp?.response?.dlVerified ?? false,
                                educationalQualification:
                                    resp?.response?.educationalQualification ?? '',
                                emailId: resp?.response?.emailId ?? '',
                                uniformIssueDate: resp?.response?.uniformIssueDate ?? null,
                                shirtSize: resp?.response?.shirtSize ?? '',
                                trouserSize: resp?.response?.trouserSize ?? '',
                                shoeSize: resp?.response?.shoeSize ?? '',
                                maskDetails: resp?.response?.maskDetails ?? false,
                            });
                            // If staffTypeId is set and it's BlueDart, fetch roll codes
                            if (isBlueDart && resp?.response?.staffType) {
                                fetchRollCodes(resp?.response?.staffType);
                            }
                            let hubShiftMapping =
                                resp?.response?.hubShiftMappings;
                            const newZoneInfo = {
                                ...zonesWithHub,
                            };
                            let operationData = [];
                            if (!!hubShiftMapping?.length) {
                                setWorkTabHubNShiftList([
                                    ...hubShiftMapping?.map((hub) => {
                                        return {
                                            hubId: hub.hubId,
                                            hubInfo: hub,
                                            business: hub?.orgCustomerId,
                                            custInfo: {
                                                id: hub?.orgCustomerId,
                                                aliasName: hub?.customerName,
                                            },
                                            primaryOperation:
                                                hub?.primaryOperation,
                                        };
                                    }),
                                    {},
                                ]);
                                hubShiftMapping?.forEach((hub, idx) => {
                                    const shiftIds = hub?.shiftLineItems;
                                    getShiftfromHubId(
                                        hub?.hubId,
                                        idx,
                                        shiftIds,
                                    );
                                });

                                operationData = resp?.response?.omsUserDetails;
                            }
                            if (
                                !hubShiftMapping?.length &&
                                !!resp?.response?.hubId
                            ) {
                                let hubID = resp?.response?.hubId;
                                let hub = {
                                    ...hubs?.find((h) => h?.id === hubID),
                                };
                                setWorkTabHubNShiftList([
                                    {
                                        hubId: hubID,
                                        hubInfo: hub,
                                        business: hub?.orgCustomerId,
                                        custInfo: {
                                            id: hub?.orgCustomerId,
                                            aliasName: hub?.customerName,
                                        },
                                        primaryOperation: hub?.primaryOperation,
                                        shiftLineItems: [],
                                    },
                                    {},
                                ]);
                                operationData = resp?.response?.omsUserDetails;
                                getShiftfromHubId(hubID, 0, []);
                            }
                            if (!!operatingCityId)
                                dispatch(
                                    getStaffCityZones(
                                        operatingCityId ?? 1,
                                        (resp) => {
                                            !isEdit && setLoading(false);
                                            operationData?.forEach((op) => {
                                                newZoneInfo[
                                                    op?.primaryOperation
                                                ] = !!op?.zones?.length
                                                    ? resp?.response?.zones?.filter(
                                                          (z) => {
                                                              return op?.zones?.includes(
                                                                  z?.id,
                                                              );
                                                          },
                                                      )
                                                    : [];
                                            });
                                            setZonesWithHub({ ...newZoneInfo });
                                        },
                                        (resp) => {
                                            !isEdit && setLoading(false);
                                        },
                                    ),
                                );

                            // console.log('getSingleSTaff SUCCESS');
                            setLoading(false);
                        }
                    },
                    () => {
                        // console.log('getSingleSTaff FAILED');
                        setLoading(false);
                    },
                ),
            );
        }
    }, []);

    useEffect(() => {
        setWorkTabHubNShiftList((prev) => {
            const allshiftIds = [];
            const newList = prev?.map((hub) => {
                let newRecord = {
                    ...hub,
                };
                if (!!shiftsWithHub?.[hub?.hubId]) {
                    newRecord = {
                        ...newRecord,
                        ...shiftsWithHub?.[hub?.hubId],
                    };
                }
                if (!!newRecord?.shifts?.length) {
                    allshiftIds?.push(...newRecord?.shifts?.map((s) => s?.id));
                }
                return newRecord;
            });
            formik.setFieldValue('shiftTimingIds', allshiftIds, true);
            return newList;
        });
    }, [shiftsWithHub]);

    useEffect(() => {
        const hasFoodHub = workTabHubNShiftList?.some(
            (hub) =>
                !!hub?.hubId &&
                hub?.primaryOperation === HUB_TYPE_ENUM.FOOD.value,
        );
        if (zonesWithHub.FOOD?.length > 0) {
            formik.setFieldValue('zones', zonesWithHub.FOOD, true);
            formik.setTouched({
                zones: false,
            });
        } else {
            if (!isEdit && hasFoodHub) {
                formik.setFieldValue('zones', zonesWithHub.FOOD, true);
                formik.setTouched({
                    zones: true,
                });
                formik.setFieldError('zones', 'Please select zone');
            } else if (!hasFoodHub) {
                // Clear zone error when no food hub is selected
                formik.setFieldError('zones', undefined);
                formik.setTouched({ zones: false });
            }
        }
    }, [zonesWithHub, workTabHubNShiftList]);

    useEffect(() => {
        setRateCardPayload((prev) => {
            return {
                ...prev,
                hubId: formik?.values?.hubId,
            };
        });
    }, [formik?.values?.hubId]);

    useEffect(() => {
        if (
            formik?.values?.salaryCycle === 'Weekly' ||
            formik?.values?.salaryCycle === 'Bi-Weekly'
        ) {
            setSalaryCycleDayList(weekList);
        } else if (formik?.values?.salaryCycle === 'Monthly') {
            setSalaryCycleDayList(weekDaysList);
        }
    }, [formik?.values?.salaryCycle, weekDaysList, weekList]);

    // Re-fetch roll codes when staffTypeId changes (BlueDart only)
    // Note: we do NOT auto-reset rollCode here — stale value simply won't match
    // the new option list, which is acceptable. The edit-load path sets rollCode
    // explicitly via setValues, and add-mode starts with '' already.
    useEffect(() => {
        if (isBlueDart && formik?.values?.staffTypeId) {
            fetchRollCodes(formik.values.staffTypeId);
        }
    }, [formik?.values?.staffTypeId]);

    useEffect(() => {
        // console.log('workTabHubNShiftList', workTabHubNShiftList);
        let hubValidation = validateHubSelection(workTabHubNShiftList);
        if (hubValidation?.hasDedicated && !hubValidation?.isValid) {
            Swal.fire({
                icon: 'error',
                title: 'HUBS',
                text:
                    hubValidation?.reason ??
                    'Cannot mix slots and normal hubs. Please check',
            });
            setLoading(false);
            return;
        }
        let isShiftOverlapping = checkoverlapping();
        isShiftOverlapping = !workTabHubNShiftList?.filter(
            (hub) => !!hub?.shifts?.length,
        )?.length;
    }, [workTabHubNShiftList]);

    const getShiftfromHubId = async (
        hubId,
        workTabHubNShiftListIndex,
        shifts = null,
    ) => {
        await dispatch(
            fetchShiftfilterList(
                {
                    hubIds: [hubId],
                },
                async (resp) => {
                    const shiftList = shifts?.map((shift) => {
                        return (
                            resp?.response?.shifts?.find(
                                (i) => i?.id === shift?.id,
                            ) ?? shift
                        );
                    });
                    setShiftsWithHub((prev) => ({
                        ...prev,
                        [hubId]: {
                            index: workTabHubNShiftListIndex,
                            shifts: shiftList,
                            shiftList: resp?.response?.shifts?.filter(
                                (shift) => !shift?.slotShift,
                            ),
                        },
                    }));
                },
                (err) => {
                    // console.log('err', err);
                },
            ),
        );
    };

    const getZonesFromHubId = async (hubId) => {
        let payload = { cityId: operatingCityId, hubIds: [hubId] };

        await dispatch(
            getchZoneList(
                payload,
                (resp) => {
                    if (resp?.response?.zones?.length)
                        setZoneOptions((prev) => {
                            return {
                                ...prev,
                                [hubId]: resp?.response?.zones,
                            };
                        });
                },
                (err) => {},
            ),
        );
    };

    const fetchHubListWithFilters = (filters, onSucess, onFailure) => {
        dispatch(getHubListWithFilters(orgId, filters, onSucess, onFailure));
    };
    const fetchBusinessList = (filters, onSucess, onFailure) => {
        dispatch(GetBusinessList(orgId, filters, onSucess, onFailure));
    };

    const handlers = useMemo(
        () => ({
            onChange: (key, value) => {
                formik.setFieldValue(key, value);
            },
            addClient: () => {
                formik.setFieldValue('clients', [
                    ...formik.values?.clients,
                    { customerId: '', staffCustCode: '' },
                ]);
            },
            removeClient: (index) => {
                formik.setFieldValue(
                    'clients',
                    formik.values?.clients?.filter((_, i) => i !== index),
                );
            },
            updateClient: (index, key, value) => {
                formik.setFieldValue(
                    'clients',
                    formik.values?.clients?.map((c, i) =>
                        i === index ? { ...c, [key]: value } : c,
                    ),
                );
            },
        }),
        [formik],
    );

    const actions = useMemo(() => {
        const isFormFieldIsSameAsInitialValues = isEqual(
            formik.values,
            formik.initialValues,
        );
        return [
            <Button
                key={1}
                variant="contained"
                color="default"
                className={`cancelButton`}
                disableElevation
                onClick={onClose}
            >
                Cancel
            </Button>,
            <Button
                key={2}
                variant="contained"
                color="primary"
                className={`saveButton`}
                disableElevation
                onClick={formik.handleSubmit}
                minWidth={100}
                style={{
                    minWidth: '108px',
                }}
                disabled={
                    loading ||
                    formik.isSubmitting ||
                    isFormFieldIsSameAsInitialValues
                }
            >
                {isEdit ? 'Edit Staff' : 'Add Staff'}
            </Button>,
        ];
    }, [
        formik.handleSubmit,
        formik.initialValues,
        formik.isSubmitting,
        formik.isValid,
        formik.values,
        isEdit,
        loading,
        onClose,
    ]);

    console.log('stateProps formik', formik.errors);

    const formProps = {
        formik,
        handlers,
        vendorList,
        clientList,
    };
    useEffect(() => {
        fetchHubListWithFilters(
            {
                orgCustomerIds: [],
            },
            () => {},
            (err) => {
                console.log('fetchHubListWithFilters err', err);
            },
        );
    }, []);

    const stateProps = {
        // useState
        overlapShifts,
        setOverlapShift,
        bothShiftsIsThere,
        setBothShiftsIsThere,
        isSubmitButtonDisabled,
        setSubmitButtonDisabled,
        allowHubZoneEdit,
        setAllowHubZoneEdit,
        shiftsWithHub,
        setShiftsWithHub,
        zoneOptions,
        setZoneOptions,
        zonesWithHub,
        setZonesWithHub,
        workTabHubNShiftList,
        setWorkTabHubNShiftList,
        vehicleTypesList,
        orgCustomerMappings,
        // salary tab
        salaryTypeList,
        salaryCycleList,
        salaryCycleDayList,
        rateCardResponse,
        filteredBaseRateTypesList,
        // Blue Dart specific
        sccList,
        rollCodeList,
        educationalQualificationOptions,
        shirtSizeOptions,
        trouserSizeOptions,
        shoeSizeOptions,
    };

    const handleOrgOverrideConfirmation = async (payload, message) => {
        const result = await Swal.fire({
            title: 'Staff exists in another org',
            text: message,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Move',
            cancelButtonText: 'No',
        });
        if (result.isConfirmed) {
            setLoading(true);
            dispatch(
                createStaff(
                    { ...payload, orgOverrideConfirmed: true },
                    async () => {
                        setLoading(false);
                        onClose();
                        showMessage('Staff Created Successfully', 'success');
                    },
                    async () => {
                        setLoading(false);
                        showMessage(
                            'Failed to create staff. Please try again.',
                            'error',
                        );
                    },
                ),
            );
        } else {
            onClose();
        }
    };

    return {
        formik,
        activeTab,
        handleTabChange,
        actions,
        loading,
        modalTitle,
        formProps,
        stateProps,
        // functions
        getShiftfromHubId,
        getZonesFromHubId,
        fetchHubListWithFilters,
        fetchBusinessList,
        isDedicatedSlotEnabled,
        isPinCodeOrg,
        isAmazonOrg,
        isBlueDartOrg: isBlueDart,
    };
}
